document.addEventListener("DOMContentLoaded", function () {
  var currentPath = window.location.pathname;

  // Pages excluded from the slide system
  var excludedPages = ["/pages/contact-1", "/pages/about"];

  if (excludedPages.includes(currentPath)) {
    // Hide footer on excluded pages
    var footer = document.querySelector(
      '[id^="shopify-section-"][id$="__footer"], #shopify-section-footer'
    );
    if (footer) footer.style.display = "none";

    document.querySelectorAll(".shopify-section").forEach(function (section) {
      if (section.querySelector(".bnz-footer-cards")) {
        section.style.display = "none";
      }
    });
    return;
  }

  var mainContent = document.getElementById("MainContent");
  if (!mainContent) return;

  // Collect all slide-eligible sections from MainContent
  var sections = Array.from(
    mainContent.querySelectorAll(".shopify-section.section")
  );

  // Include footer (lives outside MainContent)
  var footerSection = document.querySelector(
    '[id^="shopify-section-"][id$="__footer"], #shopify-section-footer'
  );
  if (footerSection) {
    footerSection.classList.add("section");
    sections.push(footerSection);
  }

  if (sections.length === 0) return;

  // --- Configuration ---
  var TRANSITION_DURATION = 800;
  var STACK_OFFSET = 20;
  var SCROLL_THRESHOLD = 20;
  var MIN_SWIPE = 50;
  var QUICK_SWIPE = 15;
  var QUICK_SWIPE_TIME = 300;
  var FLICK_VELOCITY = 0.5;

  // Header theme fallback: page path → indices of sections needing dark (black) header text.
  // Used ONLY when sections don't have a data-header-theme attribute.
  // Gradually replace by adding data-header-theme to section templates.
  var PAGE_HEADER_CONFIG = {
    "/": [1, 2, 3, 5, 6, 7],
    "/pages/le-book": [0, 3, 4],
    "/pages/tres-confidentiel-le-salon": [0, 1, 2, 3],
    "/pages/mode-demploi": [0, 1, 2],
  };

  // --- State ---
  var currentSection = 0;
  var isScrolling = false;
  var lastScrollTime = Date.now();
  var scrollTimeout;

  // --- Touch state ---
  var touchStartX = 0;
  var touchStartY = 0;
  var touchEndX = 0;
  var touchEndY = 0;
  var touchStartTime = 0;
  var lastTouchY = 0;
  var touchVelocity = 0;

  // --- Helpers ---

  function isInsideSlider(e) {
    return (
      e.target.closest(
        ".swiper, .swiper-container, .slider, [data-slider], [data-swiper], .slideshow, .product__media-list"
      ) !== null
    );
  }

  function getSwipeDirection(sx, sy, ex, ey) {
    return Math.abs(ex - sx) > Math.abs(ey - sy)
      ? (ex > sx ? "right" : "left")
      : (ey > sy ? "down" : "up");
  }

  function shouldUseDarkHeader(sectionEl, index) {
    // 1. Explicit data-header-theme attribute (on section or a child)
    var themed =
      sectionEl.querySelector("[data-header-theme]") ||
      (sectionEl.hasAttribute("data-header-theme") ? sectionEl : null);
    if (themed) {
      return themed.getAttribute("data-header-theme") === "dark";
    }

    // 2. Page-specific index fallback
    var overrides = PAGE_HEADER_CONFIG[currentPath];
    if (overrides) return overrides.includes(index);

    // 3. Auto-detect: dark-background elements → light header
    if (sectionEl.querySelector("footer, .footer")) return false;
    if (sectionEl.querySelector(".banner, .video-section, .slideshow"))
      return false;

    // Default: light background → dark header
    return true;
  }

  // --- Build slide container ---
  var container = document.createElement("div");
  container.className = "bnz-slides-container";

  sections.forEach(function (section) {
    if (section.parentNode) section.parentNode.removeChild(section);
    section.classList.add("bnz-slide");
    container.appendChild(section);
  });

  mainContent.appendChild(container);

  var spacer = document.createElement("div");
  spacer.className = "bnz-slides-spacer";
  mainContent.appendChild(spacer);

  // --- Build indicators (dots) ---
  var indicators = document.createElement("div");
  indicators.className = "bnz-slides-indicators";

  sections.forEach(function (_, i) {
    var dot = document.createElement("button");
    dot.className = "bnz-slides-dot";
    dot.setAttribute("aria-label", "Section " + (i + 1));
    dot.addEventListener("click", function () {
      goToSection(i);
    });
    indicators.appendChild(dot);
  });
  document.body.appendChild(indicators);

  // --- Build chevron navigation ---
  var chevronNav = document.createElement("div");
  chevronNav.className = "bnz-slides-chevron-nav";

  var upChevron = document.createElement("button");
  upChevron.className = "bnz-slides-chevron";
  upChevron.innerHTML =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 10.828l-4.95 4.95-1.414-1.414L12 8l6.364 6.364-1.414 1.414z" fill="currentColor"/></svg>';
  upChevron.addEventListener("click", function () {
    if (currentSection > 0) goToSection(currentSection - 1);
  });

  var downChevron = document.createElement("button");
  downChevron.className = "bnz-slides-chevron";
  downChevron.innerHTML =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" fill="currentColor"/></svg>';
  downChevron.addEventListener("click", function () {
    if (currentSection < sections.length - 1) goToSection(currentSection + 1);
  });

  chevronNav.appendChild(upChevron);
  chevronNav.appendChild(downChevron);
  document.body.appendChild(chevronNav);

  // --- UI updates ---

  function updateIndicators(index) {
    var dots = indicators.querySelectorAll(".bnz-slides-dot");
    dots.forEach(function (dot, i) {
      dot.classList.toggle("bnz-slides-dot--active", i === index);
    });
  }

  function updateChevrons(index) {
    upChevron.disabled = index === 0;
    downChevron.disabled = index === sections.length - 1;
  }

  function updateHeaderColors(index) {
    var isDark = shouldUseDarkHeader(sections[index], index);
    var color = isDark ? "#000" : "#fff";

    document.querySelectorAll(".header__menu-item span").forEach(function (el) {
      el.style.color = color;
    });

    document.querySelectorAll(".header__icon svg").forEach(function (el) {
      el.style.color = color;
      el.style.fill = color;
    });

    var logo = document.querySelector(".header__heading-logo");
    if (logo) logo.style.filter = isDark ? "invert(0)" : "invert(1)";

    // Dynamic menu underline gradient
    var styleEl = document.getElementById("bnz-header-styles");
    if (!styleEl) {
      styleEl = document.createElement("style");
      styleEl.id = "bnz-header-styles";
      document.head.appendChild(styleEl);
    }
    var grad = isDark ? "rgb(0 0 0 / 80%)" : "rgb(255 255 255 / 80%)";
    styleEl.textContent =
      ".header__menu-item::after { background: linear-gradient(to right, transparent, " +
      grad +
      ", transparent); }";
  }

  // --- Initialize positions ---
  sections.forEach(function (section, i) {
    section.style.transform =
      i === 0 ? "translate3d(0, 0, 0)" : "translate3d(0, 100%, 0)";
    section.style.zIndex = i === 0 ? sections.length : 0;
    section.style.visibility = i === 0 ? "visible" : "hidden";
  });

  updateHeaderColors(0);
  updateChevrons(0);
  updateIndicators(0);

  // --- Core transition ---
  function goToSection(index) {
    if (
      isScrolling ||
      index < 0 ||
      index >= sections.length ||
      index === currentSection
    )
      return;

    isScrolling = true;
    var direction = index > currentSection ? "down" : "up";
    currentSection = index;

    updateChevrons(index);
    updateIndicators(index);
    updateHeaderColors(index);

    sections.forEach(function (section, i) {
      var isCurrent = i === currentSection;
      var inStack =
        direction === "down" ? i < currentSection : i > currentSection;

      section.style.visibility = isCurrent || inStack ? "visible" : "hidden";

      if (isCurrent) {
        section.style.transform = "translate3d(0, 0, 0)";
        section.style.zIndex = sections.length;
        section.style.boxShadow =
          direction === "down"
            ? "0 -5px 20px rgba(0,0,0,0.15)"
            : "0 5px 20px rgba(0,0,0,0.15)";
      } else if (inStack) {
        var depth = Math.abs(currentSection - i);
        var sign = direction === "down" ? "-" : "";
        section.style.transform =
          "translate3d(0, " + sign + STACK_OFFSET * depth + "px, 0)";
        section.style.zIndex = sections.length - depth;
        section.style.boxShadow = "0 0 10px rgba(0,0,0,0.1)";
      } else {
        section.style.transform =
          "translate3d(0, " +
          (direction === "down" ? "100%" : "-100%") +
          ", 0)";
        section.style.zIndex = 0;
        section.style.boxShadow = "none";
      }
    });

    setTimeout(function () {
      isScrolling = false;
    }, TRANSITION_DURATION);
  }

  // --- Wheel handler ---
  window.addEventListener(
    "wheel",
    function (e) {
      if (isInsideSlider(e)) return;
      e.preventDefault();
      if (isScrolling) return;

      clearTimeout(scrollTimeout);
      var now = Date.now();
      var speed = Math.abs(e.deltaY) / (now - lastScrollTime);

      scrollTimeout = setTimeout(
        function () {
          if (
            e.deltaY > SCROLL_THRESHOLD &&
            currentSection < sections.length - 1
          ) {
            goToSection(currentSection + 1);
          } else if (e.deltaY < -SCROLL_THRESHOLD && currentSection > 0) {
            goToSection(currentSection - 1);
          }
        },
        speed > 0.5 ? 20 : 40
      );

      lastScrollTime = now;
    },
    { passive: false }
  );

  // --- Touch handlers ---
  window.addEventListener(
    "touchstart",
    function (e) {
      if (isInsideSlider(e)) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      lastTouchY = touchStartY;
      touchStartTime = Date.now();
      touchVelocity = 0;
    },
    { passive: true }
  );

  window.addEventListener(
    "touchmove",
    function (e) {
      if (isInsideSlider(e) || isScrolling) return;

      touchEndX = e.touches[0].clientX;
      touchEndY = e.touches[0].clientY;

      var dt = Date.now() - touchStartTime;
      if (dt > 0) {
        touchVelocity = (touchEndY - lastTouchY) / dt;
        lastTouchY = touchEndY;
        touchStartTime = Date.now();
      }

      var dir = getSwipeDirection(
        touchStartX,
        touchStartY,
        touchEndX,
        touchEndY
      );
      if (
        (dir === "up" || dir === "down") &&
        ((touchStartY > touchEndY && currentSection < sections.length - 1) ||
          (touchStartY < touchEndY && currentSection > 0))
      ) {
        e.preventDefault();
      }
    },
    { passive: false }
  );

  window.addEventListener(
    "touchend",
    function (e) {
      if (isInsideSlider(e) || isScrolling) return;

      touchEndX = e.changedTouches[0].clientX;
      touchEndY = e.changedTouches[0].clientY;

      var diffY = touchStartY - touchEndY;
      var timeDiff = Date.now() - touchStartTime;
      var dir = getSwipeDirection(
        touchStartX,
        touchStartY,
        touchEndX,
        touchEndY
      );
      var isFlick = Math.abs(touchVelocity) > FLICK_VELOCITY;

      if (dir === "up" || dir === "down") {
        if (
          Math.abs(diffY) > MIN_SWIPE ||
          (Math.abs(diffY) > QUICK_SWIPE && timeDiff < QUICK_SWIPE_TIME) ||
          isFlick
        ) {
          if (
            (diffY > 0 || touchVelocity < -FLICK_VELOCITY) &&
            currentSection < sections.length - 1
          ) {
            goToSection(currentSection + 1);
          } else if (
            (diffY < 0 || touchVelocity > FLICK_VELOCITY) &&
            currentSection > 0
          ) {
            goToSection(currentSection - 1);
          }
        }
      }
    },
    { passive: false }
  );

  // --- Keyboard handler ---
  window.addEventListener("keydown", function (e) {
    if (isScrolling) return;
    var ae = document.activeElement;
    if (
      ae &&
      (ae.tagName === "INPUT" ||
        ae.tagName === "TEXTAREA" ||
        ae.closest(".swiper, .slider"))
    )
      return;

    if (
      (e.key === "ArrowDown" || e.key === "PageDown" || e.key === " ") &&
      currentSection < sections.length - 1
    ) {
      e.preventDefault();
      goToSection(currentSection + 1);
    } else if (
      (e.key === "ArrowUp" || e.key === "PageUp") &&
      currentSection > 0
    ) {
      e.preventDefault();
      goToSection(currentSection - 1);
    } else if (e.key === "Home") {
      e.preventDefault();
      goToSection(0);
    } else if (e.key === "End") {
      e.preventDefault();
      goToSection(sections.length - 1);
    }
  });

  // Public API
  window.goToSection = goToSection;
});
